import { useContext } from "react";
import { GlobalStatesContext } from "../../context/globalStates.context";
import { useQuery } from "@tanstack/react-query";
import { getProgrammes, getUpcomingProgrammes } from "../services/programmeService";
import { queryKeys } from "../constants";

export const useFetchProgrammes = (startDate, endDate, difficulty, type, isChildFriendly, pageNumber = 1) => {
    const { searchTerm } = useContext(GlobalStatesContext);   
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.programmes, searchTerm, startDate, endDate, pageNumber],
        queryFn: () => getProgrammes(searchTerm, startDate, endDate, pageNumber)
    })

    return { data, isLoading };
}

export const useFetchUpcomingPogrames = () => {   
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.upcomingProgrammes],
        queryFn: () => getUpcomingProgrammes()
    })

    return { data, isLoading };
}
